// todo(automated-eslint-suppression) React Compiler has skipped optimizing this component because one or more React ESLint rules were disabled. React Compiler only works when your components follow all the rules of React, disabling them may result in unexpected or incorrect behavior
// eslint-disable-next-line react-compiler/react-compiler
/* eslint-disable react-hooks/rules-of-hooks */

import { Block } from 'baseui/block';
import { Button, KIND, SIZE, SHAPE } from 'baseui/button';
import { Checkbox, STYLE_TYPE, LABEL_PLACEMENT } from 'baseui/checkbox';
import { Grid, Cell } from 'baseui/layout-grid';
import { Input } from 'baseui/input';
import { StatefulPopover, TRIGGER_TYPE } from 'baseui/popover';
import { StyledLink } from 'baseui/link';
import { StyledList, StyledListItem } from 'baseui/menu';
import TagFilled from '@uber/icons/tag-filled';
import ThreeDotsFilled from '@uber/icons/three-dots-filled';
import TrashCanFilled from '@uber/icons/trash-can-filled';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { styled } from 'baseui';
import Check from 'baseui/icon/check';
import Plus from 'baseui/icon/plus';
import * as React from 'react';
import { EditModeInput } from '../common/Input';
import { FieldType, questionTypes, type FollowUpType, type QnAStateType } from '../../reducers';
import { QuestionStyleContext } from '../../question-style-context';
import { VSpacer } from '../common/layout';
import { getAllDescendentFollowUpQuestionIds, getQuestionById } from '../../reducers/selectors';
import { removeFollowup } from '../../utils/question';
import Answers from './Answers';
import FollowUps from './FollowUps';
import ImportAnswers from './ImportAnswers';
import QuestionMeta from './QuestionMeta';
import { QuestionValidation } from './QuestionValidation';
const StyledLi = styled('li', props => ({
  listStyleType: 'none',
  width: '100%',
  ...props.$theme.typography.font200
}));
type Props = {
  state: QnAStateType;
  questionId: string;
  parentId?: string;
  updateQuestion: Function;
  addQuestion: Function;
  addConditionalQuestion: Function;
  setModal: Function;
  removeQuestion: Function;
  followUp?: FollowUpType;
  followUpIdx?: number;
  followUpOwnderId?: string;
};
const Question = (props: Props) => {
  const {
    state,
    questionId,
    parentId,
    followUpIdx,
    addQuestion,
    addConditionalQuestion,
    setModal,
    removeQuestion,
    updateQuestion
  } = props;
  const question = getQuestionById(state, questionId);
  if (!question) {
    return null;
  }
  React.useEffect(() => {
    if (!question.question) {
      setEditMode(true);
    }
  }, []);
  const followUps = get(question, 'followUps') || [];
  const noFollowUps = isEmpty(followUps);
  const context = React.useContext(QuestionStyleContext);
  const {
    defaultTagVisibility
  } = context;
  const [showTag, setShowTag] = React.useState(Boolean(defaultTagVisibility));
  const [showOptions, setShowOptions] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const composeQuestionStyle = get(context, 'compose.question') || {};
  const followUpOwnerQuestion = parentId ? getQuestionById(state, parentId) : null;
  const [nameInput, setNameInput] = React.useState(question.question);
  const {
    // @ts-expect-error todo(ts-migration) TS2339 Property 'disableFollowupQuestion' does not exist on type '{ questionDecorator: (href: any, text: any, key: any) => Element; requiredHintRenderer: (isRequired: any) => Element; defaultTagVisibility: b...
    disableFollowupQuestion,
    // @ts-expect-error todo(ts-migration) TS2339 Property 'disableCopyQuestion' does not exist on type '{ questionDecorator: (href: any, text: any, key: any) => Element; requiredHintRenderer: (isRequired: any) => Element; defaultTagVisibility: boole...
    disableCopyQuestion,
    // @ts-expect-error todo(ts-migration) TS2339 Property 'disableImportAnswers' does not exist on type '{ questionDecorator: (href: any, text: any, key: any) => Element; requiredHintRenderer: (isRequired: any) => Element; defaultTagVisibility: bool...
    disableImportAnswers,
    // @ts-expect-error todo(ts-migration) TS2339 Property 'extraAnswerOptionRenderer' does not exist on type '{ questionDecorator: (href: any, text: any, key: any) => Element; requiredHintRenderer: (isRequired: any) => Element; defaultTagVisibility:...
    extraAnswerOptionRenderer,
    // @ts-expect-error todo(ts-migration) TS2339 Property 'handleExitEditMode' does not exist on type '{ questionDecorator: (href: any, text: any, key: any) => Element; requiredHintRenderer: (isRequired: any) => Element; defaultTagVisibility: boolea...
    handleExitEditMode
  } = context;
  const isFileUploadQues = question.type === questionTypes.file;
  return <React.Fragment>
      <Grid gridGaps={[20]} gridGutters={[0]} gridMargins={[0]}>
        <Cell span={[4, 8, 12]}>
          <Block padding="scale400" overrides={{
          Block: {
            style({
              $theme
            }) {
              return {
                borderWidth: $theme.borders.border300.borderWidth,
                borderColor: $theme.borders.border300.borderColor,
                borderStyle: $theme.borders.border300.borderStyle
              };
            }
          }
        }} onClick={e => {
          e.stopPropagation();
          setEditMode(true);
        }} data-testid="edit-mode">
            <Grid gridGaps={[6]} gridGutters={[6]} gridMargins={[0]}>
              <Cell span={[4, 5, 9]}>
                <EditModeInput value={question.question} editMode={editMode}>
                  <Input size={SIZE.compact} type="text" placeholder="Put question ..." value={nameInput} name={`question-${questionId}`} onChange={e => {
                  setNameInput(e.target.value);
                }} onBlur={e => {
                  updateQuestion({
                    ...question,
                    question: nameInput
                  });
                }} />
                </EditModeInput>
              </Cell>
              <Cell span={[4, 3, 3]}>
                <EditModeInput editMode={editMode} hideNoneEdit>
                  <Grid gridGaps={[0]} gridGutters={[0]} gridMargins={[0]}>
                    <Cell span={[3, 6, 9]}>
                      <Checkbox checked={get(question, 'isRequired')} checkmarkType={STYLE_TYPE.toggle} onChange={e => {
                      updateQuestion({
                        ...question,
                        isRequired: e.target.checked
                      });
                    }} labelPlacement={LABEL_PLACEMENT.right}>
                        Mandatory
                      </Checkbox>
                    </Cell>
                    <Cell span={[1, 2, 3]}>
                      <Block $style={{
                      textAlign: 'center'
                    }}>
                        <StatefulPopover triggerType={TRIGGER_TYPE.hover} accessibilityType={'tooltip'} content={<StyledList role="listbox" tabIndex={0} data-baseweb="menu">
                              <StyledListItem onClick={e => {
                          if (parentId && followUpOwnerQuestion) {
                            // remove followup question
                            const nextQuestion = removeFollowup(followUpOwnerQuestion, followUpIdx, questionId);
                            updateQuestion(nextQuestion);
                          }
                          const allDescendentIds = getAllDescendentFollowUpQuestionIds(state, questionId);
                          // remove itself
                          removeQuestion(questionId);
                          // remove descendent
                          allDescendentIds.forEach(id => {
                            removeQuestion(id);
                          });
                        }}>
                                <TrashCanFilled />
                              </StyledListItem>
                              <StyledListItem onClick={e => {
                          setShowTag(!showTag);
                        }}>
                                <TagFilled />
                              </StyledListItem>
                            </StyledList>}>
                          <StyledLink>
                            <ThreeDotsFilled />
                          </StyledLink>
                        </StatefulPopover>
                      </Block>
                    </Cell>
                  </Grid>
                </EditModeInput>
              </Cell>
              <QuestionMeta editMode={editMode} showTag={showTag} question={question} updateQuestion={updateQuestion} />
              <Cell span={[4, 5, 9]}>
                <QuestionValidation question={question} updateQuestion={updateQuestion} editMode={editMode} />
              </Cell>
            </Grid>
            {/* @ts-expect-error todo(ts-migration) TS2322 Type '{ children: Element; as: string; $styleOverrides: any; }' is not assignable to type 'IntrinsicAttributes & { $as?: "li"; } & { $style?: StyleObject | ((props: {}) => StyleObject); className?: st... */}
            <StyledLi as="li" $styleOverrides={composeQuestionStyle.li}>
              <Grid gridGaps={[0]} gridGutters={[0]} gridMargins={[0]}>
                <Cell span={[2, 5, 8]}>
                  <VSpacer />
                  {!isFileUploadQues && <Answers editMode={editMode} question={question} state={state} updateQuestion={updateQuestion} showOptions={showOptions} />}
                </Cell>
                {editMode && <Cell span={[2, 3, 4]}>
                    <Grid gridGaps={[12]} gridGutters={[0]} gridMargins={[20]}>
                      {!isFileUploadQues && <Cell span={[4, 8, 12]}>
                          <Checkbox checked={showOptions} checkmarkType={STYLE_TYPE.toggle} onChange={e => {
                      setShowOptions(!showOptions);
                    }} labelPlacement={LABEL_PLACEMENT.right}>
                            Advanced options
                          </Checkbox>
                          <Checkbox checked={get(question, 'tags').includes(FieldType.dynamicField)} checkmarkType={STYLE_TYPE.toggle} onChange={e => {
                      let tags = get(question, 'tags');
                      if (e.target.checked) {
                        tags = [...tags, FieldType.dynamicField];
                      } else {
                        tags = tags.filter(tag => tag !== FieldType.dynamicField);
                      }
                      updateQuestion({
                        ...question,
                        tags
                      });
                    }} labelPlacement={LABEL_PLACEMENT.right}>
                            Dynamic Field
                          </Checkbox>
                        </Cell>}

                      <Cell span={[4, 8, 12]}>
                        {!disableImportAnswers && !isFileUploadQues && <ImportAnswers
                    // @ts-expect-error todo(ts-migration) TS2322 Type '{ question: any; questionId: string; updateQuestion: Function; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<unknown, any, any>> & Readonly<unknown>'.
                    question={question} questionId={questionId} updateQuestion={updateQuestion} />}
                      </Cell>

                      {extraAnswerOptionRenderer && <Cell span={[4, 8, 12]}>
                          {extraAnswerOptionRenderer({
                      question,
                      updateQuestion
                    })}
                        </Cell>}

                      {editMode && <Cell span={[4, 8, 12]}>
                          {!disableFollowupQuestion && <Block marginBottom="scale100" marginRight="scale100">
                              <Button kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill}
                      // @ts-expect-error todo(ts-migration) TS2322 Type '{ children: (string | Element)[]; kind: "secondary"; size: "compact"; shape: "pill"; marginBottom: string; onClick: (e: SyntheticEvent<HTMLButtonElement, Event>) => void; }' is not assignable to...
                      marginBottom="5px" onClick={e => {
                        e.stopPropagation();
                        addQuestion(questionId);
                      }}>
                                <Plus /> Follow up
                              </Button>
                            </Block>}
                          {!disableCopyQuestion && <Block marginBottom="scale100" marginRight="scale100">
                              <Button kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill} onClick={e => {
                        setModal('copy', {
                          open: true,
                          questionId
                        });
                      }}>
                                <Plus /> Copy question
                              </Button>
                            </Block>}
                          <Block marginBottom="scale100" marginRight="scale100">
                            <Button onClick={e => {
                        e.stopPropagation();
                        if (handleExitEditMode) {
                          handleExitEditMode({
                            question
                          });
                        }
                        setEditMode(false);
                        setShowOptions(false);
                      }} size={SIZE.compact} shape={SHAPE.pill}>
                              <Check /> Done
                            </Button>
                          </Block>
                        </Cell>}
                    </Grid>
                  </Cell>}
              </Grid>
            </StyledLi>
          </Block>
        </Cell>
        {!noFollowUps && <Cell span={[4, 8, 12]}>
            <FollowUps state={state} parentId={questionId} followUps={followUps} updateQuestion={updateQuestion} addQuestion={addQuestion} addConditionalQuestion={addConditionalQuestion} setModal={setModal} removeQuestion={removeQuestion} />
          </Cell>}
        {editMode && !noFollowUps && <Cell span={[4, 8, 12]}>
            <Block paddingLeft="scale500">
              {!disableFollowupQuestion &&
          // @ts-expect-error todo(ts-migration) TS2322 Type '{ children: Element; $as: string; marginRight: string; }' is not assignable to type 'IntrinsicAttributes & BlockProps<"div"> & { $style?: StyleObject | ((props: BlockProps<"div">) => StyleObject...
          <Block $as="span" marginRight="scale100">
                  <Button kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill} onClick={e => {
              addQuestion(questionId);
            }}>
                    <Plus /> Follow up
                  </Button>
                </Block>}
              {!disableCopyQuestion &&
          // @ts-expect-error todo(ts-migration) TS2322 Type '{ children: Element; $as: string; marginRight: string; }' is not assignable to type 'IntrinsicAttributes & BlockProps<"div"> & { $style?: StyleObject | ((props: BlockProps<"div">) => StyleObject...
          <Block $as="span" marginRight="scale100">
                  <Button kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill} onClick={e => {
              setModal('copy', {
                open: true,
                questionId
              });
            }}>
                    <Plus /> Copy question
                  </Button>
                </Block>}
              {/* @ts-expect-error todo(ts-migration) TS2322 Type '{ children: Element; $as: string; marginRight: string; }' is not assignable to type 'IntrinsicAttributes & BlockProps<"div"> & { $style?: StyleObject | ((props: BlockProps<"div">) => StyleObject... */}
              <Block $as="span" marginRight="scale100">
                <Button onClick={e => {
              e.stopPropagation();
              setEditMode(false);
              setShowOptions(false);
            }} size={SIZE.compact} shape={SHAPE.pill}>
                  <Check /> Done
                </Button>
              </Block>
            </Block>
          </Cell>}
      </Grid>
    </React.Fragment>;
};
export default React.memo<Props>(Question, (prevProps, props) => {
  const question1 = getQuestionById(prevProps.state, prevProps.questionId);
  const question2 = getQuestionById(props.state, props.questionId) || {};
  const prevParentQuestion = prevProps.parentId && getQuestionById(prevProps.state, prevProps.parentId);
  const parentQuestion = props.parentId && getQuestionById(props.state, props.parentId);

  // improve leaf memo
  return isEmpty(question2.followUps) && question2 === question1 && prevParentQuestion === parentQuestion;
});